import { isExplorerOnlyMode } from "@/utils/explorerOnlyMode";

export const useExplorerOnlyMode = () => isExplorerOnlyMode();
